module.exports = __webpack_public_path__ + "static/media/grid-item-a15.3c9ba5e3.png";